import { createSelector } from 'redux-orm';
import orm from '%paysera_seat_selection/js/seatSelection/redux/model';
import dbSelector from './dbSelector';

const selectSeatByHash = createSelector(
    orm,
    dbSelector,
    (state, id) => id,
    ({ Row }, id) => Row.get({ id }),
);

export default selectSeatByHash;
